import { render, staticRenderFns } from "./TableButtonGroup.vue?vue&type=template&id=4c5461ec&scoped=true"
import script from "./TableButtonGroup.vue?vue&type=script&lang=js"
export * from "./TableButtonGroup.vue?vue&type=script&lang=js"
import style0 from "./TableButtonGroup.vue?vue&type=style&index=0&id=4c5461ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5461ec",
  null
  
)

export default component.exports